<template>
  <Icon v-if="props.iconify" :icon="props.iconify" />

  <i
    v-else
    class="icon"
    :style="
      props.color === 'false'
        ? {
            'mask-image': `url(${maskSrc})`,
            'background-color': 'currentColor',
          }
        : { 'background-image': `url(${maskSrc})` }
    "
  />
</template>

<script setup>
  import { Icon } from '@iconify/vue';
  import { computed } from 'vue'

  const props = defineProps({
    name: {
      type: String,
    },
    color: {
      type: String,
      default: 'false',
    },
    size: {
      type: String,
      default: '1em',
    },
    iconify: {
      type: String,
    }
  })

  const maskSrc = computed(() => {
    return `/img/icons/${props.name}.svg`
  })
</script>

<style scoped lang="scss">
  i.icon {
    display: inline-block;
    vertical-align: middle;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
    pointer-events: none;
    width: v-bind(size);
    height: v-bind(size);
  }
</style>
